import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import styles from "../../css";

export const CompRollUpDetails = ({ chartImage }) => {
  return (
    <View style={styles.report_container}>
      <View style={styles.big_header}>
        <Text>Cybersecurity Competencies Level Rollup</Text>
      </View>
      <View>
        <Image src={chartImage} style={{ maxHeight: "650px" }} />
      </View>
    </View>
  );
};

const ReportCompRollUp = ({ chartImage }) => {
  return (
    <View>
      <CompRollUpDetails chartImage={chartImage} />
    </View>
  );
};

export default ReportCompRollUp;
